import Vue from 'vue'
import App from './App.vue'
import vueMask from 'vue-jquery-mask';
import $ from 'jquery';
import Swal from 'sweetalert2';
window.$ = $;
window.swal = Swal;
import 'popper.js';
import 'bootstrap';
import router from './router';
Vue.config.productionTip = false;
Vue.use(vueMask);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')